import { render, staticRenderFns } from "./PersonalizedCategories.vue?vue&type=template&id=2355a470&"
import script from "./PersonalizedCategories.vue?vue&type=script&lang=js&"
export * from "./PersonalizedCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalizedCategories.vue"
export default component.exports